<template>
    <div id="motusTaxi" class="map-wrapper-container"></div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import {SET_MAP_OBJECT, AUTH_LOGOUT} from "../store/types";
    import L from 'leaflet'
    delete L.Icon.Default.prototype._getIconUrl;
    import 'leaflet.marker.slideto'
    import { tileManger } from "../services/mapProviders.service";
    import {fitters} from '../mixins/mapHelpers';
    import {carIcon} from "../assets/images/carIcon";

    export default {
        data() {
            return {
                center: [42.3, 43.8],
                zoom: 8,
                mapOptions:{
                    attributionControl: false,
                    zoomControl: false,
                    editable: true
                },

                objectMarker: null,
                markerSlideDuration: 2000,
                lastPosition: null
            }
        },
        methods: {
            isLive(){
                if(this.positionData.lastPositionLive && !this.positionData.lastPositionLive.status){
                    this.$eventBus.$emit('showAlert', {
                        content: `ობიექტი ${this.stateNumber} არ არის კავშირზე!`,
                        config: {
                            actionHandlers: [
                                {
                                    handler: ()=>{
                                        this.$store.dispatch(AUTH_LOGOUT).then(()=>{
                                            this.$router.push({name: 'authorization'})
                                        });
                                    },
                                    buttonClass: 'secondary',
                                    buttonText: 'დახურვა'
                                }
                            ],
                            type: 'error'
                        }
                    });
                    return false;
                }else{
                    return true;
                }
            },

            setMarker(){
                if(!this.objectMarker){
                    this.objectMarker = L.marker(this.positionData.position, {icon: this.getIcon(this.positionData.course)}).addTo(this.mapObject);
                    this.fitShape(this.objectMarker);
                    this.lastPosition = this.positionData.position;
                }else {
                    if(!(L.latLng(this.lastPosition).equals(L.latLng(this.positionData.position)))){
                        this.objectMarker.slideTo(this.positionData.position, {
                                duration: this.markerSlideDuration,
                                keepAtCenter: true
                            }
                        );
                        setTimeout(() => {
                            this.objectMarker.setIcon(this.getIcon(this.positionData.course));
                        }, this.markerSlideDuration);
                    }
                    this.lastPosition = this.positionData.position;
                }
            },


            getIcon(course) {
                const icon = L.Icon.extend({
                    options: {
                        iconSize: [80, 80],
                        iconAnchor: [40, 40]
                    }
                });
                return new icon({
                    iconUrl: 'data:image/svg+xml,' + carIcon.replace('{{ course }}', course)
                });
            },
        },
        watch:{
            positionData(data){
                if(data && this.isLive()){
                    this.setMarker();
                }
            }
        },
        computed:{
            ...mapGetters(['stateNumber']),
            positionData(){
                return this.$store.state.trip.positionData;
            }
        },
        mixins: [fitters],
        mounted() {
            const mapObject = L.map('motusTaxi', this.mapOptions).setView(this.center, this.zoom);
            tileManger.init(mapObject);
            this.$store.commit(SET_MAP_OBJECT, mapObject);
        }
    }
</script>

<style lang="scss">
    @import "~leaflet/dist/leaflet.css";
    .map-wrapper-container {
        width: 100%;
        height: 100%;

        .leaflet-control-zoom {
            box-shadow: none !important;
            a {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 30px !important;
                height: 30px !important;
                border-radius: 0 !important;
                background-color: $primary-color;
                color: $white;
                &:hover{
                    background-color: $secondary-color;
                }
            }
        }

        .leaflet-popup-content-wrapper,
        .leaflet-popup-tip {
            border-radius: 0;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);;
        }

        .popup-content {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            font-family: 'dejavu_sansbook';

            .popup-content-title {
                font-weight: bold;
                font-size: .9rem;
            }

            .popup-content-text {
                max-height: 200px;
                overflow-y: auto;
                margin-top: 10px;
                padding: 10px 0 5px 0;
                border-top: 1px solid $gray-2;
            }

            .popup-content-entry {
                display: flex;
                margin-top: 8px;
                padding-top: 8px;
                border-top: 1px solid $gray-2;

                .entry-label {
                    margin-right: 5px;
                    font-weight: bold;
                    min-width: 120px;
                }

            }
        }
    }
</style>